function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreeceKino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 50",
    style: {
      enableBackground: "new 0 0 100 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 9.89 1.52 2.41v-.63l41.93-.01.05 7.91h35.62c10.71-3.44 19.3 3.43 19.36 13.76.08 12.83-12.76 18.72-23.6 11.37L75 40.3l-3.81 2.3-3.6-4.95H1.85v-.47L10 29.25V9.89zm23.77 6.85 2.16-2.52 2.47 2.84.02 5.68-.63.01-4.02-6.01z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#272324"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    },
    d: "M49.82 12.52H38.28l2.66 2.81v16.12l-1.64 1.93-11.2-16.8L38.94 4.96l-11.85-.02 3.22 3.65-9.7 9.6V8.7l3.75-3.76H9.21l3.5 3.78v21.62l-3.65 4.37h15.32l-3.77-4.35V19.11l7.99 11.4.03 4.2h21.21l-2.88-3.24V15.32zm20.1 2.62 2.31-2.25v-.38l-7.91.05 2.52 2.59-.01 8.51-.43.02-7.57-11.16H51.3l2.66 2.81v16.12l-2.78 3.26h8.76l-2.87-3.24V20.19l.92.03 11.52 15.21h.41zm12.94-3.27c5.92 0 10.72 5.25 10.72 11.72 0 6.47-4.8 11.72-10.72 11.72s-10.72-5.25-10.72-11.72c.01-6.47 4.8-11.72 10.72-11.72zm-.1 3.03c2.38 0 4.31 3.93 4.31 8.78s-1.93 8.78-4.31 8.78-4.31-3.93-4.31-8.78c0-4.84 1.93-8.78 4.31-8.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f66c18"
    },
    d: "M50.79 12.52H39.25l2.66 2.81v16.12l-1.64 1.93-11.2-16.8L39.91 4.96l-11.85-.02 3.22 3.65-9.7 9.6V8.7l3.75-3.76H10.18l3.5 3.78v21.62l-3.65 4.37h15.33l-3.78-4.35V19.11l8 11.4.02 4.2h21.21l-2.88-3.24V15.32zm20.1 2.62 2.32-2.25-.01-.38-7.91.05 2.52 2.59-.01 8.51-.43.02-7.57-11.16h-7.53l2.66 2.81v16.12l-2.78 3.26h8.76l-2.87-3.24V20.19l.92.03 11.52 15.21h.41zm12.94-3.27c5.92 0 10.72 5.25 10.72 11.72 0 6.47-4.8 11.72-10.72 11.72-5.92 0-10.72-5.25-10.72-11.72.01-6.47 4.8-11.72 10.72-11.72zm-.1 3.03c2.38 0 4.31 3.93 4.31 8.78s-1.93 8.78-4.31 8.78-4.31-3.93-4.31-8.78c0-4.84 1.93-8.78 4.31-8.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#feda34"
    },
    d: "M51.68 12.52H40.13l2.67 2.81v16.12l-1.65 1.93-11.2-16.8L40.79 4.96l-11.85-.02 3.22 3.65-9.69 9.6V8.7l3.75-3.76H11.07l3.5 3.78v21.62l-3.65 4.37h15.32l-3.77-4.35V19.11l7.99 11.4.03 4.2H51.7l-2.88-3.24V15.32zm20.09 2.62 2.32-2.25v-.38l-7.91.05 2.52 2.59-.01 8.51-.43.02-7.57-11.16h-7.54l2.67 2.81v16.12l-2.78 3.26h8.76l-2.88-3.24V20.19l.93.03 11.52 15.21h.4zm12.95-3.27c5.92 0 10.72 5.25 10.72 11.72 0 6.47-4.8 11.72-10.72 11.72C78.8 35.31 74 30.06 74 23.59c0-6.47 4.8-11.72 10.72-11.72zm-.1 3.03c2.38 0 4.31 3.93 4.31 8.78s-1.93 8.78-4.31 8.78-4.31-3.93-4.31-8.78c0-4.84 1.93-8.78 4.31-8.78z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 46.255,
    cy: 3.194,
    r: 8.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    style: {
      stopColor: "#fffce7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    style: {
      stopColor: "#fdea41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    style: {
      stopColor: "#fde53f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#fdd73b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    style: {
      stopColor: "#fcbf33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    style: {
      stopColor: "#fcb12e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    style: {
      stopColor: "#ee7929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    style: {
      stopColor: "#e84b1d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.36.28c3.01 0 5.45 2.46 5.45 5.49 0 3.03-2.44 5.49-5.45 5.49-3.01 0-5.45-2.46-5.45-5.49 0-3.03 2.44-5.49 5.45-5.49z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#a)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 74.547,
    cy: 41.653,
    r: 8.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    style: {
      stopColor: "#fffce7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    style: {
      stopColor: "#fdea41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    style: {
      stopColor: "#fde53f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#fdd73b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    style: {
      stopColor: "#fcbf33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    style: {
      stopColor: "#fcb12e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    style: {
      stopColor: "#ee7929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    style: {
      stopColor: "#e84b1d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.65 38.74c3.01 0 5.45 2.46 5.45 5.49 0 3.03-2.44 5.49-5.45 5.49-3.01 0-5.45-2.46-5.45-5.49 0-3.03 2.44-5.49 5.45-5.49z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 86.32,
    cy: 41.653,
    r: 8.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    style: {
      stopColor: "#fffce7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    style: {
      stopColor: "#fdea41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    style: {
      stopColor: "#fde53f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#fdd73b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    style: {
      stopColor: "#fcbf33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    style: {
      stopColor: "#fcb12e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    style: {
      stopColor: "#ee7929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    style: {
      stopColor: "#e84b1d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.43 38.74c3.01 0 5.45 2.46 5.45 5.49 0 3.03-2.44 5.49-5.45 5.49-3.01 0-5.45-2.46-5.45-5.49-.01-3.03 2.44-5.49 5.45-5.49z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 62.517,
    cy: 41.653,
    r: 8.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    style: {
      stopColor: "#fffce7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    style: {
      stopColor: "#fdea41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    style: {
      stopColor: "#fde53f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#fdd73b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    style: {
      stopColor: "#fcbf33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    style: {
      stopColor: "#fcb12e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    style: {
      stopColor: "#ee7929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    style: {
      stopColor: "#e84b1d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.62 38.74c3.01 0 5.45 2.46 5.45 5.49 0 3.03-2.44 5.49-5.45 5.49-3.01 0-5.45-2.46-5.45-5.49 0-3.03 2.44-5.49 5.45-5.49z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 50.677,
    cy: 41.653,
    r: 8.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    style: {
      stopColor: "#fffce7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    style: {
      stopColor: "#fdea41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    style: {
      stopColor: "#fde53f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#fdd73b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    style: {
      stopColor: "#fcbf33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    style: {
      stopColor: "#fcb12e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    style: {
      stopColor: "#ee7929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    style: {
      stopColor: "#e84b1d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.78 38.74c3.01 0 5.45 2.46 5.45 5.49 0 3.03-2.44 5.49-5.45 5.49-3.01 0-5.45-2.46-5.45-5.49 0-3.03 2.44-5.49 5.45-5.49z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 38.643,
    cy: 41.653,
    r: 8.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    style: {
      stopColor: "#fffce7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    style: {
      stopColor: "#fdea41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    style: {
      stopColor: "#fde53f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#fdd73b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    style: {
      stopColor: "#fcbf33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    style: {
      stopColor: "#fcb12e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    style: {
      stopColor: "#ee7929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    style: {
      stopColor: "#e84b1d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.75 38.74c3.01 0 5.45 2.46 5.45 5.49 0 3.03-2.44 5.49-5.45 5.49-3.01 0-5.45-2.46-5.45-5.49 0-3.03 2.44-5.49 5.45-5.49z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 26.807,
    cy: 41.653,
    r: 8.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    style: {
      stopColor: "#fffce7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    style: {
      stopColor: "#fdea41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    style: {
      stopColor: "#fde53f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#fdd73b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    style: {
      stopColor: "#fcbf33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    style: {
      stopColor: "#fcb12e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    style: {
      stopColor: "#ee7929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    style: {
      stopColor: "#e84b1d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.91 38.74c3.01 0 5.45 2.46 5.45 5.49 0 3.03-2.44 5.49-5.45 5.49-3.01 0-5.45-2.46-5.45-5.49 0-3.03 2.44-5.49 5.45-5.49z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 14.773,
    cy: 41.653,
    r: 8.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    style: {
      stopColor: "#fffce7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    style: {
      stopColor: "#fdea41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    style: {
      stopColor: "#fde53f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#fdd73b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    style: {
      stopColor: "#fcbf33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    style: {
      stopColor: "#fcb12e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    style: {
      stopColor: "#ee7929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    style: {
      stopColor: "#e84b1d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.88 38.74c3.01 0 5.45 2.46 5.45 5.49 0 3.03-2.44 5.49-5.45 5.49-3.01 0-5.45-2.46-5.45-5.49 0-3.03 2.44-5.49 5.45-5.49z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#h)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreeceKino);
export default __webpack_public_path__ + "static/media/greece_kino.0d67ff9131c38b95324019a357c446cd.svg";
export { ForwardRef as ReactComponent };